import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';

const Dropdown = ({ label, items, className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div 
      ref={dropdownRef}
      className={`relative ${className}`}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        className="text-gray-700 hover:text-[#C8A870] font-medium transition-all duration-300 ease-out flex items-center gap-1 relative group px-1.5 py-2 whitespace-nowrap text-sm"
      >
        {label}
        <ChevronDown 
          className={`w-3.5 h-3.5 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} 
        />
        <span className="absolute bottom-[-4px] left-0 w-0 h-[2px] bg-[#C8A870] group-hover:w-full transition-all duration-300 ease-out"></span>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-xl shadow-2xl border border-gray-100 py-3 z-50 animate-fadeIn">
          {items.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              className="block px-6 py-3 text-gray-700 hover:bg-wazin-gold/10 hover:text-wazin-gold transition-all duration-200 border-l-4 border-transparent hover:border-wazin-gold"
              onClick={() => setIsOpen(false)}
            >
              <div className="font-semibold text-base">{item.title}</div>
              {item.description && (
                <div className="text-sm text-gray-500 mt-1">{item.description}</div>
              )}
            </Link>
          ))}
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default Dropdown;
